// Hovering a Kurnik / Obora (owner 2026-10-01): who lives there and how much room is left; the
// residents glow too (FarmAnimalLayer.setHighlight). Pure.
const plural = (n, one, few, many) => (n === 1 ? one : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? few : many);
const NOUN = { kura: ['kura', 'kury', 'kur', 'kurę'], krowa: ['krowa', 'krowy', 'krów', 'krowę'] };
const FEMININE = { obora: true };                     // "pełna / pusta" — a Kurnik is "pełny / pusty"

export function hutResidents(raw, hutId) {
  return (raw?.animals ?? []).filter((a) => a.scene === 'farm' && a.buda_placement_id === hutId).map((a) => a.id);
}

export function hutHint(raw, placement) {
  const spec = raw?.catalog?.farm?.objects?.[placement?.item];
  if (!spec || spec.kind !== 'hut') return null;
  const n = hutResidents(raw, placement.id).length;
  const [one, few, many, acc] = NOUN[spec.animal] ?? ['zwierzę', 'zwierzęta', 'zwierząt', 'zwierzę'];
  const fem = FEMININE[placement.item];
  if (n === 0) return `${spec.name_pl} · ${fem ? 'pusta' : 'pusty'} — kup ${acc} w Rynku`;
  const who = `${n === 1 || plural(n, 1, 2, 5) === 5 ? 'mieszka' : 'mieszkają'} tu ${n} ${plural(n, one, few, many)}`;
  const free = spec.holds - n;
  return `${spec.name_pl} · ${who} · ${free > 0 ? `wolne miejsca: ${free}` : fem ? 'pełna' : 'pełny'}`;
}
